/* Hearten JP — Direction B interactions
   - Fold / reveal on scroll (IntersectionObserver)
   - APPI cookie consent banner
*/
(function () {
  'use strict';

  /* ---------- Fold / reveal on scroll ---------- */
  var revealEls = document.querySelectorAll('.b-reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- APPI cookie consent ---------- */
  var banner = document.querySelector('.b-cookie');
  if (!banner) return;
  var KEY = 'hearten_cookie_consent';
  function closeBanner() { banner.classList.remove('is-open'); }
  function store(val) {
    try { localStorage.setItem(KEY, val); } catch (e) {}
    closeBanner();
  }
  if (localStorage.getItem(KEY)) {
    closeBanner();
  } else {
    // open after first paint
    requestAnimationFrame(function () { banner.classList.add('is-open'); });
  }
  var accept = banner.querySelector('[data-cookie-accept]');
  var decline = banner.querySelector('[data-cookie-decline]');
  if (accept) accept.addEventListener('click', function () { store('accepted'); });
  if (decline) decline.addEventListener('click', function () { store('declined'); });
})();
